export var SlideTypeEnum;
(function (SlideTypeEnum) {
    SlideTypeEnum["IMAGE"] = "image";
    SlideTypeEnum["VIDEO"] = "video";
    SlideTypeEnum["TEXT"] = "text";
})(SlideTypeEnum || (SlideTypeEnum = {}));
//# sourceMappingURL=slide-type.enum.js.map